'use client';
import { captureMessage, withScope } from '@sentry/nextjs';
import React, { PropsWithChildren } from 'react';

import { getGlobalArgs } from '@/root/global';
import { isLocalEnv } from '@/utils/next';

import pkg from '../../../package.json';
import { GlobalErrorPage } from '../Error';
type ErrorBoundaryProps = PropsWithChildren;

type ErrorBoundaryState = {
  hasError: boolean;
};

const isLocalDev = isLocalEnv(getGlobalArgs('NEXT_PUBLIC_ENV', 'local'));
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    withScope(scope => {
      scope.setTag('namespace', getGlobalArgs('NEXT_PUBLIC_NAMESPACE'));
      scope.setTag('microservice_name', pkg.name);
      scope.setTag('origin', 'error_boundary');
      scope.setTag('dev_mode', isLocalDev ? 'enabled' : 'disabled');

      captureMessage(JSON.stringify(errorInfo), {
        level: 'error',
      });
    });
  }

  render() {
    if (this.state.hasError) {
      return <GlobalErrorPage />;
    }

    return this.props.children;
  }
}
